function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "54B59EBC-B103-440F-A94F-9E89554035CE");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "circlar-path",
  cx: 8.75,
  cy: 8.75,
  r: 8.75
}), React.createElement("polygon", {
  id: "stroke-path",
  points: "8.04526062 3.26120558 9.45151062 3.26120558 9.45151062 14.2299556 8.04526062 14.2299556"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-701.000000, -911.000000)"
}, React.createElement("g", {
  id: "not-resolved",
  transform: "translate(701.000000, 911.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#circlar-path"
})), React.createElement("use", {
  id: "icon-color",
  fill: "#D13434",
  xlinkHref: "#circlar-path"
}), React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#stroke-path"
})), React.createElement("use", {
  id: "icon-color",
  fill: "#FFFFFF",
  transform: "translate(8.748386, 8.745581) rotate(-45.000000) translate(-8.748386, -8.745581) ",
  xlinkHref: "#stroke-path"
}))));

var SvgNotResolved = function SvgNotResolved(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotResolved, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not-resolved.69d84e45.svg";
export { ForwardRef as ReactComponent };